<template>
  <div id="skill-set">
    <div class="section padding-page-top padding-bottom">
      <div class="container">
        <div class="px-4 px-xl-2">
          <div class="page-title text-center mb-5 mb-sm-5">
            <div>MY SKILLSET</div>
            <h1 class="">
              what I
              <span class="highlight">do</span>
            </h1>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 col-xl-4 skill-left mb-xl-0 mb-5">
              <article class="card">
                <span class="wrapper">
                  <img
                    src="@/assets/img/skillset/design2.png"
                    class="py-4 px-4 card-img-top"
                    alt="design"
                  />
                  <div class="card-body text-center">
                    <h5 class="card-text">
                      Design
                    </h5>
                    <p>
                      Photo Compositions, Presentations, Flyers, Logos,
                      Stationary Design, Animations, Illustations, UI/UX and
                      more
                    </p>
                  </div>
                </span>
              </article>
            </div>
            <div class="col-12 col-md-6 col-xl-4 skill-middle mb-xl-0 mb-5">
              <article class="card">
                <span class="wrapper">
                  <img
                    src="@/assets/img/skillset/development2.png"
                    class="py-4 px-4 card-img-top"
                    alt="development"
                  />
                  <div class="card-body text-center">
                    <h5 class="card-text ">
                      Development
                    </h5>
                    <p>
                      Frontend Development, Backend Development, VueJS, NodeJS,
                      Express, MongoDb, Firebase and more
                    </p>
                  </div>
                </span>
              </article>
            </div>
            <div class="col-12 col-md-6 col-xl-4 skill-right">
              <article class="card">
                <span class="wrapper">
                  <img
                    src="@/assets/img/skillset/digital2.png"
                    class="py-4 px-4 card-img-top"
                    alt="design"
                  />
                  <div class="card-body text-center">
                    <h5 class="card-text">
                      Digital Strategy
                    </h5>
                    <p>
                      Branding, Marketing, Business Development, Partnership
                      Acquisition, Email Marketing, Blog Writing
                    </p>
                  </div>
                </span>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScrollReveal from "scrollreveal";
export default {
  data() {
    return {
      duration: 800
    };
  },
  mounted() {
    ScrollReveal().reveal(".skill-middle", {
      duration: this.duration,
      // reset: true,
      distance: "100px",
      mobile: false
    });
    ScrollReveal().reveal(".skill-left", {
      duration: this.duration,
      // reset: true,
      distance: "100px",
      origin: "left",
      delay: this.duration,
      mobile: false
    });
    ScrollReveal().reveal(".skill-right", {
      duration: this.duration,
      // reset: true,
      distance: "100px",
      origin: "right",
      delay: this.duration * 2,
      mobile: false
    });
  }
};
</script>

<style lang="scss" scoped>
.card {
  background-color: #23242d;
  overflow: hidden;
  height: 600px;

  @media (min-width: 730px) and (max-width: 1000px) {
    height: 460px;
  }

  @media (min-width: 1200px) {
    height: 500px;
  }

  .wrapper {
    transition: 0.5s transform ease;
    text-align: center;

    .card-img-top {
      mix-blend-mode: multiply;
      transition: 0.5s all ease;
    }

    .card-text {
      opacity: 0.8;
      transition: 0.8s all ease;
    }

    p {
      display: none;
      transition: 1.5s all ease;
      opacity: 0;
      visibility: hidden;
    }
  }

  &:hover,
  :active,
  :focus {
    .wrapper {
      .card-img-top {
        width: 70%;
        transform: rotate(10deg);
      }

      .card-text {
        opacity: 1;
        color: $primary;
        margin-bottom: 20px;
      }

      p {
        display: block;
        opacity: 1;
        visibility: visible;
      }
    }
  }
}
</style>
